import React, { useRef, useState } from "react";
import { useDrag, useDrop } from "react-dnd";

import style from "../styles.module.scss";
import { useDidMountEffect } from "util";
import { useTranslation } from "react-i18next";

const DND_ITEM_TYPE = "row";

const TableRows = (props) => {
    const { t } = useTranslation(["page"]);
    const { type, hide, targetCol, rowData, disabled, index, action = () => { }, maxLength } = props;
    const dropRef = useRef(null);
    const dragRef = useRef(null);
    const [buttonState, SetButtonState] = useState(false);
    const [, drop] = useDrop({
        type: DND_ITEM_TYPE,
        accept: DND_ITEM_TYPE,
        hover(item, monitor) {
            if (!dropRef.current) {
                return;
            }
            const dragIndex = item.index;
            const hoverIndex = index;
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return;
            }
            // Determine rectangle on screen
            const hoverBoundingRect = dropRef.current.getBoundingClientRect();
            // Get vertical middle
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            // Determine mouse position
            const clientOffset = monitor.getClientOffset();
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }
            // Time to actually perform the action
            !disabled && action({ type: "move", dragIndex, hoverIndex });
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = hoverIndex;
        },
        // drop: moveEnd,
    });

    const [{ isDragging }, drag, preview] = useDrag({
        item: { index },
        type: DND_ITEM_TYPE,
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    const opacity = isDragging ? 0.5 : 1;

    !disabled && preview(drop(dropRef));
    !disabled && drag(dragRef);

    const ordbycol = targetCol.find((v) => v.col === "orderBy");
    return (
        <>
            <tr ref={dropRef} style={{opacity}}
                className={`${rowData?.selected && style.selected}  ${hide ? style.hide : ""}`}>
                {!!ordbycol && (
                    <td ref={ordbycol.disabled ? null : dragRef}
                        className={`${style.textCenter} ${props.admin ? style.dragTd : ''}`}>
                        {rowData.orderBy}
                    </td>
                )}

                <>
                    {targetCol.map((c, i) => {
                        if (c.col === "orderBy") {
                            return null;
                        } else {
                            return (
                                <td
                                    key={type + "_td" + i}
                                    colSpan={c.colSpan || "1"}
                                    style={{textAlign: c.textAlign || "left"}}
                                    className={`${c.selectAble ? style.selectable : ""}`}
                                    onClick={() => {
                                        if (c.selectAble) {
                                            action({type: "select", index: index});
                                        }
                                    }}
                                >
                                    <div
                                        contentEditable={(props.admin && !c.readOnly)}
                                        suppressContentEditableWarning={true}
                                        onBlur={(e) => {
                                            if (e.target.innerHTML !== rowData[c.col]) action({
                                                type: "change",
                                                index,
                                                name: c.col,
                                                value: e.target.innerHTML
                                            });
                                        }}
                                        dangerouslySetInnerHTML={{__html: rowData[c.col]}}
                                        onKeyUp={(e) => {
                                            // if(e.keyCode === 8) readOnly = true;
                                            const ml = c.maxLength ?? maxLength;
                                            if (e.target.innerText.length > ml) {
                                                SetButtonState(true);
                                            } else {
                                                SetButtonState(false);
                                            }
                                        }}
                                    ></div>
                                </td>
                            );
                        }
                    })}
                </>
                {
                    props.admin && <td className={`${style.textCenter}`}>
                        <div className={`${style.tBtnBox}`}>
                            <button
                                disabled={buttonState}
                                className={`${style.tBtn} ${style.update} ${rowData.isUpdate ? style.action : ""}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    action({type: "updateComplete", index});
                                }}
                            >
                                {t("modify")}
                            </button>
                            {/* rowData.active : 활성 비활성 ( DB에서 받아와야함 ) */}
                            <button
                                style={{width: "max-content"}}
                                className={`${style.tBtn} ${rowData.disableYn === "N" ? style.content : style.sub}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    action({type: "disable", index});
                                }}
                            >

                                {rowData.disableYn === "N" ? t("active") : t("inactive")}

                            </button>
                        </div>
                    </td>
                }

            </tr>
        </>
    );
};

export default TableRows;
